export default "__VITE_ASSET__Cv1eM8PX__"